import script from "./FunboxLocationList.vue?vue&type=script&setup=true&lang=ts"
export * from "./FunboxLocationList.vue?vue&type=script&setup=true&lang=ts"

import "./FunboxLocationList.vue?vue&type=style&index=0&id=3fcf4ab4&lang=scss&scoped=true"

import exportComponent from "/data/apps/fbe-location-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fcf4ab4"]])

export default __exports__